import React, { useState, useEffect } from "react";
import {
  Card,
  Grid,
  MenuItem,
  Box,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { perspectiveOptions } from "../../models/BoatOrdering";
import {
  getSelectedModal,
} from "../../store/slices/BoatOrdering/BoatOrderingSelector";
import { useSelector } from "react-redux";
import stockimage from "../../_assets/images/default-img.png";


interface IOverlayImages {
  boatModelId: number;
  boatOptionChoiceId: number;
  boatPerspectiveId: number;
  id: number;
  layerOrder: number;
  mediaUrl: string;
  perspectiveName: string;
}

const BoatCardComponent = () => {
  const selectedModal = useSelector(getSelectedModal);
  const [overLayImages, setOverLayImages] = useState<IOverlayImages[]>([]);

  const [perspective, setPerspective] = useState<String>("Side");

  const primaryImage = selectedModal?.layeredMedia?.find(
    (media: any) => media?.perspectiveName === perspective
  );
  const secondaryImage = selectedModal?.layeredMedia?.find(
    (media: any) => media?.perspectiveName !== perspective
  );

  useEffect(() => {
    if (selectedModal) {
      let list: any = [];
      selectedModal?.sections?.forEach((section: any) => {
        section?.options?.forEach((option: any) => {
          option.choices?.forEach((choice: any) => {
            if (choice?.preSelected) {
              list.push(...choice.layeredMedia);
            }
          });
        });
      });
      const filterList: any = list?.filter((el: any) => el);
      setOverLayImages(filterList);
    }
  }, [selectedModal]);

  const _renderImagePreview = (type: String) => {
    return (
      <>
        {overLayImages
          ?.filter((item: IOverlayImages) => item.perspectiveName === type)
          ?.map((image: any, index: number) => {
            return (
              <img
                alt=""
                key={index}
                src={image?.mediaUrl}
                style={{ zIndex: image?.layerOrder }}
                className="panel-image"
              />
            );
          })}
      </>
    );
  };

  return (
    <Card sx={{ minWidth: 275 }} className="step-active-box">
      <Grid container>
        <Grid xs={6} item>
          <Box>
            <FormControl size="small" className="boatViewSelect">
              <InputLabel id="demo-simple-select-label">Perspective</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Perspective"
                value={perspective}
                onChange={(e) => setPerspective(e.target.value)}
              >
                {perspectiveOptions?.map((option: any, index: number) => (
                  <MenuItem value={option.value} key={index}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid xs={6} item>
          <div className="active-step-thumb">
            <div className="primary-image">
              <img
                alt=""
                src={ secondaryImage?.mediaUrl ?? stockimage }
              />
              {_renderImagePreview(perspective === "Top" ? "Side" : "Top")}
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container className="active-step-image">
        <Grid xs={12} item>
          <div className="primary-image">
            <img
              alt=""
              className="boat-image"
              src={ primaryImage?.mediaUrl ?? stockimage }
            />
            {_renderImagePreview(perspective)}
          </div>
        </Grid>
      </Grid>
    </Card>
  );
};
export default BoatCardComponent;
